<template>
    <div>logout</div>
</template>

<script>
    export default {
        name: "Logout",
        created () {
            this.$storage.remove('access_token')
            this.$storage.remove('refresh_token')
            this.$router.push('/login');
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/modules/Logout.vue